export enum passwordTypeEnum {
    text = 'text',
    password = 'password',
}

export enum passwordIconEnum {
    text = 'far fa-eye-slash',
    password = 'far fa-eye',
}
